export default "__VITE_ASSET__9a82766b__"